// extracted by mini-css-extract-plugin
var _1 = "src-components-common-EditForm-module__readonly";
var _2 = "src-components-common-EditForm-module__source_editor";
export { _1 as "readonly", _2 as "source_editor" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"readonly\":\"src-components-common-EditForm-module__readonly\",\"source_editor\":\"src-components-common-EditForm-module__source_editor\"}";
        // 1776408149151
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  